import { lazy } from 'react';
import Route from '@interfaces/Route';
import { pathEnum } from '@/enums/pathEnum';
import { getWitchEnv as isProduction } from '@/utils/getWitchEnv';

export const newSimpleUpdatePage: Route = {
  path: `/calculation/${pathEnum.SIMPLE_UPDATE}/new`,
  exact: true,
  auth: true,
  groups: ['owner', 'admin', 'user'],
  component: lazy(() => import('../../pages/InContruction')),
};
export const listSimpleUpdatePage: Route = {
  path: `/calculation/${pathEnum.SIMPLE_UPDATE}`,
  exact: true,
  auth: true,
  groups: ['owner', 'admin', 'user'],
  component: lazy(() => import('../../pages/InContruction')),
};
export const editSimpleUpdatePage: Route = {
  path: `/calculation/${pathEnum.SIMPLE_UPDATE}/edit/:accountId`,
  exact: true,
  auth: true,
  groups: ['owner', 'admin', 'user'],
  component: lazy(() => import('../../pages/InContruction')),
};
// financing
export const financingPage: Route = {
  path: `/calculation/${pathEnum.FINANCING}`,
  exact: true,
  auth: true,
  groups: ['owner', 'admin', 'user'],
  component: lazy(() => import('../../pages/InContruction')),
};
// current account
export const newCurrentAccountPage: Route = {
  path: `/calculation/${pathEnum.CURRENT_ACCOUNT}/new`,
  exact: true,
  auth: true,
  groups: ['owner', 'admin', 'user'],
  component: lazy(() => import('../../pages/calculations/Current/AccountForm')),
};
export const listCurrentAccountPage: Route = {
  path: `/calculation/${pathEnum.CURRENT_ACCOUNT}`,
  exact: true,
  auth: true,
  groups: ['owner', 'admin', 'user'],
  component: lazy(() => import('../../pages/calculations/Current/AccountList')),
};
export const editCurrentAccountPage: Route = {
  path: `/calculation/${pathEnum.CURRENT_ACCOUNT}/edit/:accountId`,
  exact: true,
  auth: true,
  groups: ['owner', 'admin', 'user'],
  component: lazy(() => import('../../pages/calculations/Current/AccountForm')),
};

export const editUpdateAccountPage: Route = {
  path: `/calculation/${pathEnum.AUTOMATED_UPDATE}/edit/:accountId`,
  exact: true,
  auth: true,
  groups: ['owner', 'admin', 'user'],
  component: lazy(
    isProduction()
      ? () => import('../../pages/InContruction')
      : () => import('../../pages/calculations/Automated/AccountForm/AutomatedEditAccountForm')
  ),
};
export const listUpdateAccountPage: Route = {
  path: '/calculation/automated-update',
  exact: true,
  auth: true,
  groups: ['owner', 'admin', 'user'],
  component: lazy(
    isProduction()
      ? () => import('../../pages/InContruction')
      : () => import('../../pages/calculations/Automated/AccountList')
  ),
};
export const newUpdateAccountPage: Route = {
  path: `/calculation/${pathEnum.AUTOMATED_UPDATE}/new`,
  exact: true,
  auth: true,
  groups: ['owner', 'admin', 'user'],
  component: lazy(
    isProduction()
      ? () => import('../../pages/InContruction')
      : () => import('../../pages/calculations/Automated/AccountForm/AutomatedCreateAccountForm')
  ),
};

export const Routes: Route[] = [
  listSimpleUpdatePage,
  newSimpleUpdatePage,
  editSimpleUpdatePage,
  listCurrentAccountPage,
  newCurrentAccountPage,
  editCurrentAccountPage,
  editUpdateAccountPage,
  listUpdateAccountPage,
  newUpdateAccountPage,
  financingPage,
];

export default Routes;
